"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WfsParamSourceMapServer = void 0;
var olExtent = require("ol/extent");
var WfsParamSourceMapServer = /** @class */ (function () {
    function WfsParamSourceMapServer(WfsBboxRequestParameter, params) {
        if (params === void 0) { params = {}; }
        this.WfsBboxRequestParameter = WfsBboxRequestParameter;
        this.params = params;
    }
    WfsParamSourceMapServer.prototype.getWfsParams = function (maxFeatureCount, typeName, bbox) {
        var requestParams = {
            service: "WFS",
            request: this.params.request || "Getfeature",
            version: this.params.version || "2.0.0",
            outputFormat: this.params.outputFormat || "geojson",
            typeNames: typeName,
            srsName: this.params.srsName || "EPSG:3857"
        };
        if (maxFeatureCount) {
            requestParams.maxFeatures = maxFeatureCount;
        }
        if (bbox && !olExtent.isEmpty(bbox)) {
            requestParams.bbox = bbox.join(",") + ", " + requestParams.srsName;
        }
        return requestParams;
    };
    return WfsParamSourceMapServer;
}());
exports.WfsParamSourceMapServer = WfsParamSourceMapServer;
//# sourceMappingURL=WfsParamSourceMapServer.js.map